<template>
  <div class="home">
    <section class="hero pd-font uppercase spacing background">
      <nav
        class="navbar"
        role="navigation"
        aria-label="dropdown navigation"
        v-if="!isMobile"
      >
        <div class="navbar-menu is-active" id="navMenu">
          <div class="navbar-start navbar">
            <div class="navbar is-left">
              <a @click="login" class="left navbar-item">
                <i class="fas login-icon" :class="getLoginClass(user)"></i>
              </a>
            </div>
          </div>
        </div>
      </nav>
      <div class="hero-body">
        <div class="container has-text-centered">
          <img src="@/assets/logo_white.png" style="width: 100px" />
          <h1 class="title pd-font has-text-white">Project Destination</h1>
        </div>
      </div>
    </section>

    <div class="hero pd-intro is-primary">
      <div class="section">
        <div class="hero-body has-text-centered">
          <div class="columns is-centered is-vcentered">
            <div class="column is-one-third">
              <h4 class="title is-4 pd-font uppercase spacing">
                Market your company at KTH
              </h4>
              <p>
                Project Destination organizes events where students and
                companies meet and establish contact for collaborations at KTH.
                Through our wide network and marketing channels we will reach
                out to the candidates you are looking for.
                <br />
                <br />
              </p>

              <div>
                <a
                  class="sub-font"
                  href="https://drive.google.com/file/d/1AqEGMhBFSzFQl5ERSg034wfdvOm1e6Bb/view"
                  target="_blank"
                  ><div class="button stylised-button">Magazine 21/22</div> </a
                ><br />
              </div>

              <p>
                <br />
                Get in touch!
                <br />
                <a
                  href="mailto:sales@projectdestination.se"
                  class="is-underlined sub-font"
                  >projectmanager@projectdestination.se</a
                >
              </p>

              <br />

              <h4 class="title is-4 pd-font uppercase spacing">
                Our current partners 22/23
              </h4>
              <Partners />
            </div>

            <div class="column is-one-third">
              <img src="@/assets/logo_white.png" style="border-radius: 0.5em" />
              <small class="spaced is-pulled-right sub-font"
                >Project Destination</small
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero pd-intro is-white">
      <div class="hero-body has-text-centered">
        <div class="section">
          <h1 class="title pd-font uppercase spacing">Upcoming events</h1>
          <div class="container">
            <div class="content pd-font">
              <div class="columns">
                <div class="column is-one-fifth"></div>
                <div class="parent column">
                  <Events />
                </div>
                <div class="column is-one-fifth"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <h1 class="title pd-font uppercase spacing">Recent events</h1>
          <div class="container">
            <div class="content pd-font">
              <div class="columns is-centered">
                <div class="column is-one-fifth"></div>
                <div class="column">
                  <Events :recent="true" />
                </div>
                <div class="column is-one-fifth"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <TheTeam />
  </div>
</template>
<script>
import Hero from "@/components/Hero";
import HeroSmall from "@/components/HeroSmall";
import Level from "@/components/Level";
import Tiles from "@/components/Tiles";
import Columns from "@/components/Columns";
import Intro from "@/components/Intro";
import TheTeam from "@/components/TheTeam";
import Events from "@/components/Events";
import Profile from "@/components/Profile";
import Partners from "@/components/Partners";
import { TRIP } from "@/constants/home";

import { isMobileDevice } from "@/helpers";

import { mapState } from "vuex";
const MAGAZINE_LINK =
  "https://firebasestorage.googleapis.com/v0/b/project-destination-file-hosting/o/magazine.pdf?alt=media&token=3931e497-286f-41a7-a50c-0839bbfc81c9";
export default {
  name: "home",
  components: {
    TheTeam,
    Hero,
    Level,
    Events,
    Tiles,
    Columns,
    HeroSmall,
    Intro,
    Profile,
    Partners,
  },
  data: () => {
    return {
      MAGAZINE_LINK,
    };
  },
  methods: {
    login() {
      this.$store.dispatch("login/openModal");
    },
    handleClick(path) {
      this.$router.push(path);
    },
    navigate() {
      this.$router.push("/event/MB7T0YsFI2Jil7GiQ2xn");
      this.$ga.event("Home page", "Clicked main button");
    },
    getLoginClass(user) {
      return user ? "fa-door-open" : "fa-door-closed";
    },
  },
  computed: {
    ...mapState({
      content: (state) => state.content.HOME_PAGE_DATA,
      user: (state) => state.user.userIsAuthenticated,
    }),
    TRIP: () => TRIP,
    isMobile() {
      return isMobileDevice();
    },
  },
  created() {
    this.$store.dispatch("content/getHomePageData");
  },
};
</script>
<style scoped lang="scss">
$pd-pink: #ef9bc1;

.background {
  background: linear-gradient(rgba($pd-pink, 0.5), rgba($pd-pink, 0.8)),
    url(../assets/sky.jpg) center !important;
  background-size: cover !important;
}
.logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 30px;
  height: 150px;
  width: auto;
}
.navbar-item:hover {
  opacity: 0.5;
  background: inherit;
}
.stylised-button {
  border: 1px solid white;
  background: transparent;
  color: inherit;

  cursor: pointer;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: calc(0.375em - 1px);
  padding-left: 0.75em;
  padding-right: 0.75em;
  padding-top: calc(0.375em - 1px);
  text-align: center;
  white-space: nowrap;

  -webkit-box-shadow: 3px 3px 0px 3px $pd-pink;
  box-shadow: 3px 3px 0px 3px $pd-pink;

  transition: all 200ms ease;
}
.stylised-button:hover {
  color: inherit;

  -webkit-box-shadow: 1px 1px 0px 1px $pd-pink;
  box-shadow: 1px 1px 0px 1px $pd-pink;
  transform: translate(2px, 2px);
}
.login-icon {
  color: #fff;
}
</style>
